export default __webpack_public_path__ + "static/media/ban-mobile-image-4.112b35ea.jpg";